import { render, staticRenderFns } from "./C5.vue?vue&type=template&id=6474fe19&scoped=true"
import script from "./C5.vue?vue&type=script&lang=js"
export * from "./C5.vue?vue&type=script&lang=js"
import style0 from "./C5.vue?vue&type=style&index=0&id=6474fe19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474fe19",
  null
  
)

export default component.exports